import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { delay } from 'rxjs/operators';
import { LoadingService } from '@app/core/services';

@Component({
    selector: 'sl-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        MatProgressSpinnerModule,
        AsyncPipe,
    ],
})
export class LoadingComponent {
	loading$ = this.loadingService.loading$.pipe(delay(0));

	constructor(private readonly loadingService: LoadingService) {}
}
